import { render, staticRenderFns } from "./AccettazioneAbruzzoEdit.vue?vue&type=template&id=756db9a7"
import script from "./AccettazioneAbruzzoEdit.vue?vue&type=script&lang=js"
export * from "./AccettazioneAbruzzoEdit.vue?vue&type=script&lang=js"
import style0 from "./AccettazioneAbruzzoEdit.vue?vue&type=style&index=0&id=756db9a7&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports